import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } 
from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UsersService } from '../../services/users.service';
import { LoginUser, User } from '../../interfaces/users.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  standalone: false,
  templateUrl: './register.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent {
  registerForm: FormGroup;

  constructor(private fb: FormBuilder, private usersService: UsersService, private snackBar: MatSnackBar, private router: Router) {
    this.registerForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      repwd: ['', [Validators.required]],
      //acceptPolicy: [false, Validators.requiredTrue]
    }, { validators: this.passwordsMatchValidator });
  }

  passwordsMatchValidator(group: FormGroup): { [key: string]: boolean } | null {

    const password = group.get('password')?.value;
    const repassword = group.get('repwd')?.value;


    return password === repassword ? null : { passwordsMismatch: true };

  }


  ngOnInit(): void {
    this.registerForm.get('repwd')?.valueChanges.subscribe(() => {
      const password = this.registerForm.get('password')?.value;
      const repassword = this.registerForm.get('repwd')?.value;
      if (password === repassword) {
        this.registerForm.get('repwd')?.setErrors(null);
      } else {
        this.registerForm.get('repwd')?.setErrors({ passwordsMismatch: true });
      }
    });
  }


  onSubmit(): void {
    if (this.registerForm.valid) {
      const { name, email, password, surname, accept_policy } = this.registerForm.value;

      // Prepare the user data
      const user: LoginUser = { email, password, accept_policy };

      // Call the UsersService to create the user
      const redirectUrl = window.location.origin + '/confirm-email';
      this.usersService.register(user, redirectUrl).subscribe({
        next: (response: any) => {
          this.snackBar.open('Użytkownik został utworzony poprawnie. Sprawdź swoją skrzynkę e-mail, aby aktywować konto.', 'Zamknij', {
            duration: 29000,
            panelClass: ['success-snackbar'],
            horizontalPosition: 'center', // Center horizontally
            verticalPosition: 'bottom',
          });
          this.router.navigate(['/logowanie']);
        },
        error: (err: any) => {
          let errorMessage = err.error?.detail || 'An error occurred';
          if (errorMessage.includes('Email already exists')) {
            errorMessage = 'Użytkownik o podanym adresie e-mail już istnieje!';
            this.registerForm.get('email')?.setErrors({ emailExist: true });
          }

          this.snackBar.open(errorMessage, 'Zamknij', {
            duration: 20000,
            panelClass: ['error-snackbar'],
            horizontalPosition: 'center', // Center horizontally
            verticalPosition: 'bottom',
          });
        },
      });
    }
  }

}
